import React, { useEffect, useState } from "react";
import { RiMentalHealthFill } from "react-icons/ri";
import TestQuestion from "./TestQuestion";
import {physicalWellnessData} from "../../demodata/Question"
import { fetchEvaluation } from "../../api/Evaluation";
import EditorRenderer from "../EditorRenderer";




const Willness = () => {

     const [evaluation, setEvaluation] = useState([]);
      const [parsedBlocks, setParsedBlocks] = useState([]);
    
      useEffect(() => {
        const getEvaluation = async () => {
          const data = await fetchEvaluation();
          setEvaluation(data);
        };
        getEvaluation();
      }, []);
    
     const evaluationFilter = evaluation.filter(
        (item) => item.category?.name.toLowerCase() === "physicalwellnesstest"
      );
    
    useEffect(() => {
      if (!parsedBlocks.length && evaluationFilter.length) {
        let blocksArray = [];
        try {
          const raw = evaluationFilter[0]?.description;
          if (raw) {
            const outer = JSON.parse(raw);
            const inner = outer[0];
            if (inner?.blocks && Array.isArray(inner.blocks)) {
              blocksArray = inner.blocks;
            }
          }
        } catch (err) {
          console.error("Parsing error:", err);
        }
    
        setParsedBlocks(blocksArray);
      }
    }, [evaluationFilter, parsedBlocks.length]);
    
  
  return (
    <div className="flex flex-col gap-4 mb-[4rem]">

       {parsedBlocks.length > 0 && <EditorRenderer blocks={parsedBlocks} />}
      

     
      <h2 className="sm:text-2xl text-xl font-bold text-gray-400 mt-[1rem]">
        ভিজিট + ফি:
      </h2>
        <div className="overflow-x-auto mb-[2rem]">
        <table className="min-w-full">
          <thead>
            <tr>
              <th className="border border-gray-300 text-gray-400 py-1 px-5 text-xl">০৩ টেস্ট প্যাকেজ</th>
              <th className="border border-gray-300 text-gray-400 py-1 px-5 text-xl">সরাসরি</th>
              <th className="border border-gray-300 text-gray-400 py-1 px-5 text-xl">অনলাইন</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="border border-gray-300 text-gray-400 py-2 px-5 text-xl">
                থট টেস্ট + মাইন্ড টেস্ট + স্বাস্থ্যগত টেস্ট
              </td>

              <td className="border border-gray-300 text-gray-400 py-2 px-5 text-xl text-center">
                2000/-
              </td>
              <td className="border border-gray-300 text-gray-400 py-2 px-5 text-xl text-center">
                2500/-
              </td>
            </tr>
            
          </tbody>
        </table>
      </div>
      <p className="text-gray-400  text-xl text-justify mt-[1rem]">
        আপনার সন্তানকে REVIVE করতে আজই Physical Wellness Test করুন !
      </p>

      <div className="flex gap-4 items-center mb-[4rem]">
        <p className="text-gray-300  text-xl">
          অথবা WhatsApp করুন-{" "}
          <strong className="text-[#22BEFF]">01711055752</strong>
        </p>
          <button  className="px-[1.25rem] py-[0.5rem] text-base border border-[#22beff]  text-[#22beff] hover:text-[#081a28] hover:bg-[#22beff] rounded-md font-bold cursor-pointer" onClick={() => window.open("https://forms.gle/MWgJ4zyJh3nDr6YdA", "_blank")}>
            অ্যাপয়েন্টমেন্ট
          </button>
      </div>

      <TestQuestion questionData={physicalWellnessData} />
    </div>
  );
};

export default Willness;
